import React from "react";
import { cn } from "@/src/lib/utils";

/**
 * The app's `ListingSubtleButton`: grey (#EBEBEB), rounded 12, 46px tall, centred label.
 * Every "Show more" / "Show all …" / "Message host" on the listing page. Full width on
 * mobile; on desktop it sizes to its label unless `fullWidth`.
 */
const SubtleButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & { fullWidth?: boolean }
>(({ className, fullWidth = false, type = "button", ...props }, ref) => (
  <button
    ref={ref}
    type={type}
    className={cn(
      "flex h-[46px] w-full items-center justify-center rounded-xl bg-[#EBEBEB] px-6 text-base font-semibold text-ink transition-colors hover:bg-[#DDDDDD] active:scale-[0.99] disabled:opacity-60",
      !fullWidth && "md:w-auto",
      className,
    )}
    {...props}
  />
));

SubtleButton.displayName = "SubtleButton";

export default SubtleButton;
